import React, { useState, useEffect } from 'react';
import { notification, Spin } from 'antd';
import Carousel from 'react-alice-carousel';
import { useWindowSize } from 'hooks';

import BudgetListItem from 'components/BudgetListItem';
import FooterListItem from './FooterListItem';
import PieChart from 'components/Charts/Pie';
import EmptyState from 'components/EmptyState';

import Api from 'config/api';

import { getYearAndQuaterItems } from 'utils/helpers';

import './Gdp.scss';

export default function GdpDetails({ udpateTitleBar }) {
  const [activeFooterItem, setActiveFooterItem] = useState('');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const { width } = useWindowSize();

  useEffect(() => {
    const getGdp = async () => {
      try {
        setLoading(true);
        const { data } = await Api.get('website/get-gdp');
        const { year, quarter } = data?.data[0];
        const activeYearAndQuater = year + ' ' + quarter;

        setData(data?.data);
        setActiveFooterItem(activeYearAndQuater);
        handleUpdateTitleBar(activeYearAndQuater);
      } catch ({ message, status }) {
        notification.error({
          message: `Status code: ${status}`,
          description: `Failed to load Unemployment Data. ${message}`,
        });
      }
      setLoading(false);
    };
    getGdp();
  }, []);

  const colors = [
    '#1E8449',
    '#77B9CE',
    '#b32e2e',
    '#EB5757',
    '#A6A6A6',
    '#F2994A',
  ];

  const handleUpdateTitleBar = (activeYearAndQuater) => {
    const activeTitle = `Gross Domestic Product (GDP)/${activeYearAndQuater}`;
    udpateTitleBar(activeTitle);
  };

  const getTotal = (key, array) => {
    return array.reduce((a, b) => a + (b[key] || 0), 0);
  };

  const getDataToRender = () => {
    const yearAndQuarter = activeFooterItem.split(' ');
    const year = yearAndQuarter[0];
    const quarter = yearAndQuarter[1];

    return data?.filter(
      (data) => data?.year === parseInt(year) && data?.quarter === quarter
    );
  };

  const total = getTotal('value', getDataToRender());

  const converToPercentage = getDataToRender().map((item) => {
    const percentage = (item.value / total) * 100;
    const newItem = {
      ...item,
      value: percentage.toFixed(2),
    };
    return newItem;
  });

  const series = converToPercentage.map((item) => parseFloat(item.value));

  const yearAndQuarterList = getYearAndQuaterItems(data)?.map((item, index) => (
    <FooterListItem
      item={item}
      key={index}
      className='ml-1 mr-1'
      active={item === activeFooterItem}
      setActiveFooterIndex={() => setActiveFooterItem(item)}
    />
  ));

  const responsive = {
    0: { items: 3 },
    300: { items: 5 },
  };

  return (
    <Spin spinning={loading}>
      <div>
        <div className='gdp-details'>
          {series.length > 0 && (
            <PieChart
              labels={getDataToRender().map((item) => item.sector)}
              series={series}
              colors={colors}
              type='pie'
            />
          )}

          <div className='gdp-details__budgets'>
            {getDataToRender().length > 0 ? (
              converToPercentage?.map((budget, index) => (
                <BudgetListItem
                  item={budget}
                  key={index}
                  color={colors[index]}
                />
              ))
            ) : (
              <EmptyState />
            )}
          </div>
        </div>

        {width > 370 && (
          <div className='d-flex justify-content-around p-1 mb-2 mt-2'>
            {yearAndQuarterList}
          </div>
        )}

        {width <= 370 && (
          <div className='gdp-details__footer'>
            <Carousel
              responsive={responsive}
              items={yearAndQuarterList}
              disableDotsControls
              mouseTracking
              infinite
            />
          </div>
        )}
      </div>
    </Spin>
  );
}
